var _defs, _g, _polygon, _polygon2, _polygon3, _path, _polygon4, _polygon5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 325.23 198.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#eaeaea;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:#1a1a1a;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -15.63,
    y1: 3.67,
    x2: 334.03,
    y2: 75.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dbdbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#dddede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e9e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -26.05,
    y1: 54.15,
    x2: 323.6,
    y2: 126.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dbdbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#dedfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e9e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 231.52,
    y1: 153.53,
    x2: -146.31,
    y2: 47.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dbdbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e9e9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "25.36 5.8 25.51 18.29 35.07 12.48 34.91 0 25.36 5.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "34.99 0 0 0.35 0.12 21.04 12.49 13.57 22.61 7.46 34.99 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0.12 21.04 0.08 33.52 9.81 27.72 9.65 15.23 0.12 21.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "25.33 5.8 9.65 15.23 298.71 180.18 314.39 170.75 25.33 5.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.65 15.23 9.81 27.72 298.16 192.67 298.71 180.18 9.65 15.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "290.08 185.4 290.08 198.18 325.23 197.53 325.07 185.05 290.08 185.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "290.08 185.4 325.07 185.05 324.96 164.36 312.58 171.83 302.46 177.93 290.08 185.4"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "127.15 40.76 127.11 52.8 132.61 55.98 132.6 58.36 124.52 53.7 124.56 39.27 127.15 40.76"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "142.53 49.64 142.52 52.05 136.7 48.7 136.69 52.13 141.66 55 141.65 57.31 136.69 54.44 136.68 58.33 142.51 61.7 142.5 64.08 134.08 59.22 134.12 44.79 142.53 49.64"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "154.27 56.42 154.23 70.85 151.65 69.36 146.64 56.96 146.61 66.45 144.02 64.95 144.06 50.52 146.65 52.02 151.67 64.45 151.69 54.93 154.27 56.42"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M161.48,60.39A9.84,9.84,0,0,1,165,63.63a9.65,9.65,0,0,1,1.49,4.42l-2.52-1.45a5.35,5.35,0,0,0-.76-2.25,4.68,4.68,0,0,0-1.63-1.52c-.87-.51-1.54-.51-2,0a4.58,4.58,0,0,0-.71,3v.92a9.06,9.06,0,0,0,.74,3.87,5.34,5.34,0,0,0,2.2,2.42c1,.56,1.66.72,2.08.49V71l-2.36-1.36v-2.2l4.94,2.85,0,5.76a2.42,2.42,0,0,1-2,.35,8.39,8.39,0,0,1-2.83-1.1,9.91,9.91,0,0,1-2.86-2.47,11.1,11.1,0,0,1-1.89-3.47,12.47,12.47,0,0,1-.68-4v-1a7.58,7.58,0,0,1,.64-3.38,2.39,2.39,0,0,1,1.84-1.36A4.58,4.58,0,0,1,161.48,60.39Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "178.02 70.13 178.01 72.54 174.17 70.33 174.13 82.34 171.54 80.85 171.58 68.83 167.78 66.64 167.79 64.22 178.02 70.13"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "189.72 76.88 189.67 91.31 187.09 89.82 187.11 83.64 182.06 80.72 182.04 86.91 179.45 85.41 179.49 70.98 182.08 72.47 182.06 78.33 187.11 81.25 187.13 75.39 189.72 76.88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLength);
export default __webpack_public_path__ + "static/media/length.febac8309d688f21d09407d3e2f8e3c9.svg";
export { ForwardRef as ReactComponent };